module.exports = __webpack_public_path__ + "static/media/logo_black.f4c906a7.svg";